import { Button } from "@common/index";
import styles from "./styles.module.scss";
import img from "./img/img.png";

export const ChangeHabbits = ({ onNextStep, onTrackEvent }) => {
  return (
    <div id="breakdown" className={styles.container}>
      <div className={styles.content}>
        <img src={img} alt="slimdown" className={styles.image} />
        <div className={styles.hints}>
          <h4>You can always change your habits for the better </h4>
          <p className={styles.description}>
            {" "}
            Major life changes can impact your weight — and that’s completely
            normal. With the right plan and guidance, lasting progress is
            absolutely possible.
          </p>
          <p className={styles.descriptionSecond}>
            We’re here to support you every step of the way {" "}
            <strong>until you reach your goal.</strong>
          </p>
        </div>
      </div>
      <Button
        variant="walky"
        onClick={() => {
          onNextStep();
          onTrackEvent();
        }}
      >
        Continue
      </Button>
    </div>
  );
};
